import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { DeepLinkComponent } from './deep-link/deep-link.component';
import { HomeComponent } from './home/home.component';
import { PrivacyPolicyComponent } from './privacy-policy/privacy-policy.component';
import { provideFirebaseApp, initializeApp } from '@angular/fire/app';
import { provideFirestore, getFirestore } from '@angular/fire/firestore';
import { environment } from '../environments/environment';
import { DynamicLinkService } from '../services/dynamicLinkService';
import {
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';

@NgModule({
  declarations: [
    AppComponent,
    DeepLinkComponent,
    HomeComponent,
    PrivacyPolicyComponent,
  ],
  imports: [BrowserModule, AppRoutingModule, MatProgressSpinnerModule],
  providers: [
    provideAnimationsAsync(),
    provideFirebaseApp(() => initializeApp(environment.firebase)),
    provideFirestore(() => getFirestore()),
    DynamicLinkService,
    provideHttpClient(withInterceptorsFromDi()),

    // { provide: FIREBASE_OPTIONS, useValue: environment.firebase }, // Older syntax, not recommended with provideFirebaseApp
    // getAnalytics, // Add getAnalytics to providers if you need it
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
